<div class="item-wrapper"
     *ngIf="is_installable">
  <div class="item p-1rem full-width shadow-md">
    <img class="item-icon"
         [src]="icon"
         *ngIf="!color; else avatar">
    <ng-template #avatar>
      <app-avatar [size]="36"
                  [color]="color"
                  [name]="name"></app-avatar>
    </ng-template>
    <h5 class="item-title">{{ name }}</h5>
    <mat-chip-list>
      <mat-basic-chip *ngIf="is_new && !is_premium && !in_development"
                      class="chip-new"
                      disabled
                      selected>NEW</mat-basic-chip>
      <mat-basic-chip *ngIf="is_premium"
                      class="chip-premium"
                      disabled
                      selected>PREMIUM</mat-basic-chip>
      <mat-basic-chip *ngIf="in_development"
                      class="chip-in-dev"
                      disabled
                      selected>IN DEV</mat-basic-chip>
    </mat-chip-list>
  </div>
</div>
